import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  Snackbar,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  ButtonGroup,
  CircularProgress,
  Breadcrumbs,
  HomeIcon,
  FormControl,
  Select,
  InputLabel,
  MuiAlert,
  MenuItem,
  NavLink,
  makeStyles,
  withStyles,
  useTheme,
  commonService,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  AddBoxIcon,
  SearchIcon,
  ClearIcon,
  AddIcon,
  SpeedIcon,
} from "../../../common";
import FilterListIcon from "@material-ui/icons/FilterList";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "5rem",
  },
  btnStyle: {
    backgroundColor: "#1DBF73",
    color: "white",
    fontWeight: "400",
    "&:hover": {
      backgroundColor: "#11a962",
    },
  },
  listIcon: { width: 20, paddingRight: theme.spacing(0.5) },

  table: {
    marginTop: "1.5rem",
  },
  rowPadding: {
    padding: "0.125rem 0.25rem 0 0",
  },
  formControl: {
    margin: theme.spacing(1),
    // minWidth: 120,
  },
  selectEmpty: {
    // marginTop: theme.spacing(2),
  },
  link: {
    display: "flex",
    textDecoration: "none",
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20,
  },
  active: {
    border: "1px solid #1DBF73",
    textTransform: "Capitalize",
    color: "#1DBF73",
    backgroundColor: "#1DBF7333",
  },
  disabled: {
    border: "1px solid #1DBF73",
    textTransform: "Capitalize",
    color: "#BEBDBD",
  },
  borderRemove: {
    borderBottom: "none",
    paddingLeft: "0",
  },
  btnIcon: {
    paddingRight: "5px",
    fontSize: "20px",
  },
}));
const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));
export default function LevelWiseAccount() {
  const classes = useStyles();
  const classes1 = useStyles1();
  const theme = useTheme();

  const [userType, setUserType] = useState("");
  const [level, setLevel] = useState("");
  const [accountInfo, setAccountInfo] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [updatedBy, setUpdatedBy] = useState("");

  const [levelWiseAccountList, setLevelWiseAccountList] = useState([]);
  const [accountsList, setAccountsList] = useState([]);
  const [levelTypeList, setLevelTypeList] = useState([]);

  const [count, setCount] = React.useState(20);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [errorMsgBody, setErrorMsgBody] = useState("");
  const [successMsgBody, setSuccessMsgBody] = useState("");
  const [error, setError] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [dataTableIsLoading, setDataTableIsLoading] = React.useState(true);
  const [status, setStatus] = useState("");

  const [filterShow, setFilterShow] = useState(false);

  const levelWiseAccountInactiveHandler = async (e, id, status) => {
    let requestObj = {
      level_account_id: id,
      status: status,
    };
    const res = await commonService.updatelevelWiseAccount(requestObj);
    //  console.log("update limit", res);
    res?.code === 200 && setOpen(true);
    setSuccessMsgBody(res.messages);
    handleSearch(page, level, userType, accountInfo, createdBy, updatedBy);
    res?.code !== 200 && setError(true);
    // setErrorMsgBody(res.messages);
    if (res && res.messages) {
      setErrorMsgBody(res.messages);
    } else {
      setErrorMsgBody("something is wrong");
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleErrorClose = (event) => {
    setError(false);
  };

  const handleSearch = async () => {
    setDataTableIsLoading(true);
    setLevelWiseAccountList([]);
    const res = await commonService.getLevelWiseAccountList(
      page,
      level,
      userType,
      accountInfo,
      createdBy,
      updatedBy,
      status
    );
    if (res.code === 200 && res.data.level_wise_accounts.length === 0) {
      setError(true);
      setErrorMsgBody("No Data Found");
      setDataTableIsLoading(false);
    } else if (res.code === 200) {
      setLevelWiseAccountList(res && res.data && res.data.level_wise_accounts);
      setDataTableIsLoading(false);
    } else {
      setError(true);
      setErrorMsgBody(res.messages);
      setDataTableIsLoading(false);
    }
  };

  const StyledTableCell = withStyles((theme) => ({
    root: {
      //   padding: '0.125rem 0.25rem',
    },
    head: {
      backgroundColor: theme.palette.common.white,
      fontSize: "1.125rem",
      letterSpacing: "0.014375rem",
      fontWeight: "500",
      color: "#2B335E",
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  const TablePaginationActions = (props) => {
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleBackButtonClick = (event) => {
      setLevelWiseAccountList([]);

      onChangePage(event, page - 1);

      commonService
        .getLevelWiseAccountList(
          page - 1,
          level,
          userType,
          accountInfo,
          createdBy,
          updatedBy
        )
        .then((res) => {
          if (res.code === 200 && res.data.level_wise_accounts.length === 0) {
            setError(true);
            setErrorMsgBody("No Data Found");
          } else if (res.code === 200) {
            setLevelWiseAccountList(
              res && res.data && res.data.level_wise_accounts
            );
          } else {
            setError(true);
            setErrorMsgBody(res.messages);
          }
        });
    };

    const handleNextButtonClick = (event) => {
      setLevelWiseAccountList([]);
      setCount(count + parseInt(20));
      onChangePage(event, page + 1);
      commonService
        .getLevelWiseAccountList(
          page + 1,
          level,
          userType,
          accountInfo,
          createdBy,
          updatedBy
        )
        .then((res) => {
          if (res.code === 200 && res.data.level_wise_accounts.length === 0) {
            setError(true);
            setErrorMsgBody("No Data Found");
          } else if (res.code === 200) {
            setLevelWiseAccountList(
              res && res.data && res.data.level_wise_accounts
            );
          } else {
            setError(true);
            setErrorMsgBody(res.messages);
          }
        });
    };

    return (
      <div className={classes1.root}>
        {/* <IconButton
            onClick={handleFirstPageButtonClick}
            disabled={page === 0}
            aria-label="first page"
          >
            {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
          </IconButton> */}
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        {/* <IconButton
            onClick={handleLastPageButtonClick}
            disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            aria-label="last page"
          >
            {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
          </IconButton> */}
      </div>
    );
  };

  const ClearBtn = () => {
    setUserType("");
    setLevel("");
    setAccountInfo("");
    setCreatedBy("");
    setUpdatedBy("");
    setStatus("");
  };

  const handleChangePage = (event, newPage) => {
    //  console.log("newpage", newPage);
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    //  console.log("rowperpage", event);
    setRowsPerPage(parseInt(event.target.value, 15));
    setPage(0);
  };

  const getLevels = async () => {
    const levelType = await commonService.getLevel("");
    setLevelTypeList(levelType.data?.levels);
  };
  const getAccountss = async () => {
    const accounts = await commonService.getAccounts();
    setAccountsList(accounts.data?.accounts);
  };

  useEffect(() => {
    getLevels();
    getAccountss();

    handleSearch();
  }, []);

  return (
    <Container maxWidth="xl" className={classes.root}>
      <Snackbar
        open={open}
        autoHideDuration={1500}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleClose} severity="success">
          {successMsgBody}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={error}
        autoHideDuration={1500}
        onClose={handleErrorClose}
      >
        <Alert onClose={handleErrorClose} severity="error">
          {errorMsgBody}
        </Alert>
      </Snackbar>
      <Breadcrumbs style={{ marginTop: "10px" }} aria-label="breadcrumb">
        <NavLink
          to="/dashboard"
          style={{ color: "#2B335E99" }}
          className={classes.link}
        >
          <HomeIcon className={classes.icon} />
          Home
        </NavLink>
        <NavLink
          to="/account-setup/view-all"
          style={{ color: "#2B335E99" }}
          className={classes.link}
        >
          <SpeedIcon className={classes.icon} />
          Account SetUp
        </NavLink>
        <Typography style={{ color: "#2B335E" }} className={classes.link}>
          <AddBoxIcon className={classes.listIcon} /> List
        </Typography>
      </Breadcrumbs>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          style={{
            textAlign: "left",
            margin: "15px 0",
            color: "#2B335E",
            fontSize: "25px",
            flex: 3,
          }}
        >
          Account SetUp List
        </Typography>

        <div>
          <NavLink
            to="/account-setup/create"
            variant="contained"
            style={{ height: "30px", textDecoration: "none", float: "right" }}
          >
            <Button
              // className={classes.btnStyle}
              className="btn btn-primary btn-block"
              size="medium"
              variant="contained"
              color="primary"
            >
              <AddIcon style={{ paddingRight: "5px" }} /> Create Account SetUp
            </Button>
          </NavLink>

          <Button
            size="medium"
            variant="contained"
            color="primary"
            className="btn btn-primary"
            style={{ float: "right", marginRight: 10 }}
            onClick={(e) => setFilterShow(!filterShow)}
          >
            <FilterListIcon style={{ paddingRight: "5px" }} />
          </Button>
        </div>
      </div>

      {filterShow && (
        <Paper style={{ padding: "20px" }}>
          <Typography
            style={{
              textAlign: "left",
              marginBottom: "10px",
              color: "#2B335E",
              fontSize: "21px",
            }}
          >
            Filter by
          </Typography>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                id="userType"
              >
                <InputLabel id="demo-simple-select-filled-label">
                  Account Type
                </InputLabel>
                <Select
                  labelid="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={userType}
                  onChange={async (e) => {
                    setUserType(e.target.value);

                    if (e.target.value === "charge") {
                      const accounts = await commonService.getSelectedAccounts(
                        e.target.value
                      );
                      setAccountsList(accounts.data?.accounts);
                    } else if (e.target.value === "cashback") {
                      const accounts = await commonService.getSelectedAccounts(
                        e.target.value
                      );
                      setAccountsList(accounts.data?.accounts);
                    } else if (e.target.value === "reward") {
                      const accounts = await commonService.getSelectedAccounts(
                        e.target.value
                      );
                      setAccountsList(accounts.data?.accounts);
                    } else {
                      const accounts = await commonService.getAccounts();
                      setAccountsList(accounts.data?.accounts);
                    }
                  }}
                  label="Account Type"
                >
                  <MenuItem value="">
                    <span>None</span>
                  </MenuItem>
                  <MenuItem value="charge">
                    <span>Charge</span>
                  </MenuItem>
                  <MenuItem value="cashback">
                    <span>Cashback</span>
                  </MenuItem>
                  <MenuItem value="reward">
                    <span>Reward</span>
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                label="Account Info"
                id="account_info"
              >
                <InputLabel id="demo-simple-select-filled-label">
                  Account Info
                </InputLabel>
                <Select
                  labelid="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  label="Account Info"
                  value={accountInfo}
                  onChange={(e) => setAccountInfo(e.target.value)}
                >
                  <MenuItem value="">
                    <span>None</span>
                  </MenuItem>
                  {accountsList.map((user) => (
                    <MenuItem key={user.account_no} value={user.account_no}>
                      {user.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                label="Level"
                id="Level"
              >
                <InputLabel id="demo-simple-select-filled-label">
                  Level
                </InputLabel>
                <Select
                  labelid="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  label="Level"
                  value={level}
                  onChange={(e) => setLevel(e.target.value)}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {levelTypeList.map((user) => (
                    <MenuItem value={user.id}>{user.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                id="transactionType"
              >
                <InputLabel id="demo-simple-select-filled-label">
                  Status
                </InputLabel>
                <Select
                  label="Status"
                  labelid="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <MenuItem value="1">Active</MenuItem>
                  <MenuItem value="0">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Divider style={{ margin: "10px 0" }} />
          <Grid
            item
            container
            xl={12}
            justify="flex-end"
            alignItems="flex-end"
            className={classes.btnContainer}
          >
            <Box mr={5}>
              <Button
                variant="contained"
                className={classes.cancelBtn}
                onClick={ClearBtn}
              >
                <ClearIcon className={classes.btnIcon} /> Clear
              </Button>
            </Box>
            <Box mr={3} mt={2}>
              <Button
                variant="contained"
                color="secondary"
                className="btn btn-primary btn-block"
                onClick={handleSearch}
              >
                <SearchIcon className={classes.btnIcon} />
                Filter
              </Button>
            </Box>
          </Grid>
        </Paper>
      )}

      {dataTableIsLoading === true ? (
        <Box mt={15}>
          {" "}
          <CircularProgress
            size={80}
            className={classes.progress}
            thickness={2}
          />
        </Box>
      ) : (
        <TableContainer component={Paper} className={classes.table}>
          {levelWiseAccountList && levelWiseAccountList.length > 0 && (
            <>
              <Table
                aria-labelledby="tableTitle"
                size="small"
                aria-label="simple table"
                //  style={{ width: "max-content" }}
              >
                <TableHead>
                  <TableRow
                    className={classes.tableHeader}
                    style={{ height: "70px" }}
                  >
                    <StyledTableCell>Level</StyledTableCell>
                    <StyledTableCell>Account Type</StyledTableCell>
                    <StyledTableCell>Account Info</StyledTableCell>
                    <StyledTableCell>Created By</StyledTableCell>
                    <StyledTableCell>Created At</StyledTableCell>
                    <StyledTableCell>Updated By</StyledTableCell>
                    <StyledTableCell>Updated At</StyledTableCell>
                    <StyledTableCell>Status</StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {levelWiseAccountList &&
                    levelWiseAccountList.length > 0 &&
                    levelWiseAccountList.map((item) => (
                      <>
                        <StyledTableRow
                          key={item.id}
                          style={{ cursor: "pointer" }}
                        >
                          <StyledTableCell>{item.level}</StyledTableCell>
                          <StyledTableCell>{item.type}</StyledTableCell>
                          <StyledTableCell>
                            {" "}
                            {item.account_info}
                          </StyledTableCell>
                          <StyledTableCell>{item.created_by}</StyledTableCell>
                          <StyledTableCell>{item.created_at}</StyledTableCell>
                          <StyledTableCell>{item.updated_by}</StyledTableCell>
                          <StyledTableCell>{item.updated_at}</StyledTableCell>
                          <StyledTableCell className={classes.borderRemove}>
                            {" "}
                            {item.status === "Active" ? (
                              <ButtonGroup
                                size="small"
                                aria-label="small outlined button group"
                              >
                                <Button className={classes.active}>
                                  Active
                                </Button>
                                <Button
                                  className={classes.disabled}
                                  onClick={(e) =>
                                    levelWiseAccountInactiveHandler(
                                      e,
                                      item.id,
                                      0
                                    )
                                  }
                                >
                                  Inactive
                                </Button>
                              </ButtonGroup>
                            ) : (
                              <ButtonGroup
                                size="small"
                                aria-label="small outlined button group"
                              >
                                <Button
                                  className={classes.disabled}
                                  onClick={(e) =>
                                    levelWiseAccountInactiveHandler(
                                      e,
                                      item.id,
                                      1
                                    )
                                  }
                                >
                                  Active
                                </Button>
                                <Button className={classes.active}>
                                  Inactive
                                </Button>
                              </ButtonGroup>
                            )}
                          </StyledTableCell>
                        </StyledTableRow>
                      </>
                    ))}
                </TableBody>
              </Table>
              <TablePagination
                //  showfirstbutton="true"
                //  showlastbutton="true"
                component="div"
                count={levelWiseAccountList.length}
                pagesize={15}
                rowsPerPageOptions={[10, 20, 50]}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                SelectProps={{
                  inputProps: { "aria-label": "rows per page" },
                  native: true,
                }}
                ActionsComponent={TablePaginationActions}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </>
          )}

          {levelWiseAccountList && levelWiseAccountList.length <= 0 && (
            <Table
              aria-labelledby="tableTitle"
              size="small"
              aria-label="simple table"
            >
              <TableHead>
                <TableRow
                  className={classes.tableHeader}
                  style={{ height: "70px" }}
                >
                  <StyledTableCell>Level</StyledTableCell>
                  <StyledTableCell>Account Type</StyledTableCell>
                  <StyledTableCell>Account Info</StyledTableCell>
                  <StyledTableCell>Created By</StyledTableCell>
                  <StyledTableCell>Created At</StyledTableCell>
                  <StyledTableCell>Updated By</StyledTableCell>
                  <StyledTableCell>Updated At</StyledTableCell>
                  <StyledTableCell>Status</StyledTableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <StyledTableRow>
                  <StyledTableCell style={{ backgroundColor: "white" }}>
                    <h6 className="p-4">No data found!</h6>
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          )}
        </TableContainer>
      )}
    </Container>
  );
}
